module.exports = __webpack_public_path__ + "static/covid-3-ce554690b8b879d89e1d50c7f1c807dc.png";